import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../src/assets/img/bookEdit.png';
import _imports_1 from '../../../src/assets/img/bookChose.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-50bc590d"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hr"
  }, null, -1);
});

var _hoisted_2 = {
  class: "category"
};
var _hoisted_3 = {
  style: {
    "font-weight": "bold"
  }
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 您的藏书共");

var _hoisted_5 = {
  style: {
    "color": "#bf2020"
  }
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode("本 ");

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "15px",
      "margin-right": "5px"
    }
  }, null, -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, " 编辑 ", -1);
});

var _hoisted_9 = [_hoisted_7, _hoisted_8];
var _hoisted_10 = {
  class: "editDel"
};

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 删除");

var _hoisted_12 = {
  key: 0
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    style: {
      "width": "15px",
      "margin-right": "5px"
    }
  }, null, -1);
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, " 完成 ", -1);
});

var _hoisted_15 = [_hoisted_13, _hoisted_14];
var _hoisted_16 = {
  class: "book_windows"
};
var _hoisted_17 = {
  key: 0,
  class: "book_box"
};
var _hoisted_18 = ["src", "onClick"];
var _hoisted_19 = {
  class: "book_title"
};
var _hoisted_20 = {
  class: "book_author"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
  key: 1,
  style: {
    "text-align": "center",
    "margin-top": "81px",
    "color": "#a59c9c"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "我的书架",
    back: true
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, " " + _toDisplayString(_ctx.totalNum) + " ", 1), _hoisted_6]), !_ctx.editState && _ctx.totalNum != 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "look-rank",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.changeEdit(true);
    })
  }, _hoisted_9)) : _createCommentVNode("", true), _ctx.editState ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "isEdit",
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    function () {
      return _ctx.deleteBook && _ctx.deleteBook.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _ctx.delNum != 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(_ctx.delNum) + ")", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "editFinish",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.changeEdit(false);
    })
  }, _hoisted_15)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_ctx.totalNum != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booklist, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "flex-col book_item"
    }, [item.coverPic ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "book_img",
      src: _ctx.baseurl + item.coverPic,
      alt: "",
      onClick: function onClick($event) {
        return _ctx.toDetail(item);
      }
    }, null, 8, _hoisted_18)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, _toDisplayString(item.bookName), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(item.author), 1), _ctx.editState ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "circle",
      onClick: function onClick($event) {
        return _ctx.circleEdit(item, index);
      }
    }, " ✔ ", 8, _hoisted_21)) : _createCommentVNode("", true)]);
  }), 128))])) : _createCommentVNode("", true), _ctx.totalNum == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 快去添加图书吧… ")) : _createCommentVNode("", true), _ctx.totalNum != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 2,
    pagesize: 12,
    "total-num": _ctx.totalNum,
    onChangPage: _ctx.changPage
  }, null, 8, ["total-num", "onChangPage"])) : _createCommentVNode("", true)])], 64);
}